import script from "./RestockBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestockBtn.vue?vue&type=script&lang=ts&setup=true"

import "./RestockBtn.vue?vue&type=style&index=0&id=484fe3a6&lang=scss&scoped=true"
import "./RestockBtn.vue?vue&type=style&index=1&id=484fe3a6&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484fe3a6"]])

export default __exports__